import { QueryClient } from '@tanstack/react-query';
var queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: Infinity,
            retry: false,
            refetchOnWindowFocus: false
        }
    }
});
export default queryClient;
